"use strict";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const buttons = document.querySelectorAll(".filter-btn");
        const wrapper = document.querySelector("#blog-posts-wrapper");

        // 🚨 SE NÃO EXISTE, NÃO EXECUTA O MÓDULO
        if (!wrapper || buttons.length === 0) {
            return;
        }

        const skeleton = document.querySelector("#blog-skeleton");

        function showLoading() {
            if (skeleton) skeleton.style.display = "block";
            wrapper.style.display = "none";
        }

        function hideLoading() {
            if (skeleton) skeleton.style.display = "none";
            wrapper.style.display = "";
        }

        function loadPosts(cat = "all", page = 1) {
            showLoading();

            const formData = new FormData();
            formData.append("action", "filter_blog_posts");
            formData.append("cat", cat);
            formData.append("page", page);

            fetch(usAjax.ajaxurl, {
                method: "POST",
                body: formData,
            })
                .then((res) => res.text())
                .then((html) => {
                    wrapper.innerHTML = html;
                    hideLoading();
                    bindPagination(cat);
                });
        }

        // Clique nos botões
        buttons.forEach((btn) => {
            btn.addEventListener("click", () => {
                buttons.forEach((b) => b.classList.remove("is-active"));
                btn.classList.add("is-active");

                const cat = btn.dataset.cat;
                loadPosts(cat);
            });
        });

        // Paginação AJAX
        function bindPagination(cat) {
            const links = document.querySelectorAll(".o-pagination a");

            links.forEach((link) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();

                    const url = new URL(link.href);
                    const page = url.searchParams.get("pagina") ?? 1;

                    loadPosts(cat, page);
                });
            });
        }

        // Carregamento inicial — skip if a search term is active (PHP already rendered results)
        const searchTerm = new URLSearchParams(window.location.search).get(
            "busca",
        );
        if (!searchTerm) {
            loadPosts();
        } else {
            bindPagination("all");
        }
    });
}
